import React from "react";
import { Carousel } from "react-bootstrap";
import "../css/Principal.css";
import varsha from "../asset/Principal/Mrs. Varsha Mauje.png";
import anant from "../asset/Principal/Shri. Anant Shankar Dhadve.png";
import sanika from "../asset/Principal/Mrs. Sanika Santoh Sarpole.png";
import sara from "../asset/Principal/Mrs. Sara Shaikh.png";
import mukesh from "../asset/Principal/Mr. Mukesh H Pandey.png";
import priya from "../asset/Principal/Mrs. Priya Kalambe.png";

const principals = [
  {
    name: "Mrs. Chandra Giyanchandai",
    designation: "Principal - SMG Kids",
    quote:
      "Education is not the filling of a pail, but the lighting of a fire. – W.B. Yeats.  At SMG Kids, we ignite curiosity and creativity through our play-way methods, fostering a love for learning. Our nurturing environment supports holistic growth, ensuring children thrive with joy and excitement. Grateful for the vision of our management, the trust of parents, and the dedication of our teachers, we remain committed to inspiring young minds to flourish",
    image: varsha,
  },
  {
    name: "Mr. Anant Shankar Dhadve",
    designation: "Principal - SMG Vidyamandir",
    quote:
      "Parenting requires balance—don’t trust blindly, but guide with care. Instill discipline, encourage independence, and protect them from distractions. Praise their efforts and provide firm boundaries to nurture their growth. A healthy society starts with raising children to be responsible and grounded.",
    image: anant,
  },
  {
    name: "Ms. Sanika Santosh Sarpole",
    designation: "Principal - SMG Vidyamandir",
    quote:
      "Guru Brahma, Guru Vishnu, Guru Devo Maheshwara, Guru Sakshat Parabrahm, Tasmai Shri Guruve Namah. S.M.G. Vidyamandir, established by Om Sai Shikshan Sanstha, is committed to delivering quality education since its inception in Diva. With creative leadership and dedication, the school fosters excellence and continues to gain recognition through its innovative initiatives and collective efforts.",
    image: sanika,
  },
  {
    name: "Mrs. Sara Shaikh",
    designation: "Principal - SMG English Primary School",
    quote:
      "It fills me with immense pride to reflect on the 25-year journey of SMG English School. Under the visionary leadership of Chairman Mr. Maruti Gaikar and Managing Director Mr. Swapnil Gaikar, we have shaped future leaders. Our recent accolades, including the 'Most Interactive Learning Program' award and the Star Education Award, affirm our commitment to excellence. Embracing the National Education Policy 2020, we focus on academic and character development, preparing students for the challenges ahead. Thank you for your continued trust, and here's to another 25 years of shaping young minds.",
    image: sara,
  },
  {
    name: "Mr. Mukesh H. Pandey",
    designation: "Principal - SMG English Secondary School & Junior College",
    quote:
      "Every great journey begins with a single purposeful step. For 25 years, Om Sai Shikshan Sanstha has flourished, driven by visionary leadership and teamwork. With dedication to quality education and values, we have shaped a successful and bright future for our students. Here's to continued growth and success together.",
    image: mukesh,
  },
  {
    name: "Mrs. Priya Kalambe",
    designation: "Principal - SMG Vidyalaya & Junior College",
    quote:
      "Celebrating 25 years of excellence, our journey has been shaped by dedication, passion, and community. From humble beginnings to a beacon of education, we’ve fostered curiosity, creativity, and character. With resilience and vision, we embrace the future, continuing to inspire and build futures. Here’s to the next chapter of growth and impact.",
    image: priya,
  },
];

const Principal = () => {
  return (
    <div>
      <section id="Principal">
        <div className="container">
          <div className="row">
            <h1 className="Principal-Desk">Principal Desk</h1>
            <div
              id="carouselExampleControls"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                {principals.map((principal, index) => (
                  <div
                    className={`carousel-item ${index === 0 ? "active" : ""}`}
                    key={index}
                  >
                    <div className="row">
                      <div className="quote">
                        <p>{principal.quote}</p>
                      </div>

                      <h5 className="principal-name">{principal.name}</h5>
                      <p className="designation">{principal.designation}</p>
                    </div>
                  </div>
                ))}
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Principal;
